import { PluginCommands } from "molstar/lib/mol-plugin/commands";
import { Vec3 } from "molstar/lib/mol-math/linear-algebra";
export function focusCoords(molstar, coords) {
    const vec = Vec3.create(coords[0], coords[1], coords[2]);
    PluginCommands.Camera.Focus(molstar, { center: vec, radius: 5 });
}
